<template>
    <div class="activity-details-card">
        <div class="activity-header">
            <span class="closeDrawer material-icons" @click="closeDrawer">close</span>
            <div class="activity-header-content">
                <SearchResultAvatar v-if="entity" :entity="entity" size="medium" />
                <div>
                    <div class="activity-type">{{ activityType }}</div>
                    <h2 class="activity-title">
                        {{ title }}
                    </h2>
                </div>
            </div>
        </div>

        <div class="activity-content">
            <div class="activity-subheader-wrapper">
                <slot name="sub-header"></slot>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import actions from '@/store/actions'
import SearchResultAvatar from '@/components/Search/avatar'

export default {
    components: {
        SearchResultAvatar,
    },
    props: {
        activityType: {
            type: String,
            required: true,
        },
        entity: {
            type: Object,
            required: false,
            default() {
                return null
            },
        },
        title: {
            type: String,
            required: true,
        },
    },
    methods: {
        closeDrawer() {
            this.$store.dispatch(actions.clearRightDrawer)
        },
    },
}
</script>

<style>
div.activity-details-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    & > * {
        flex-shrink: 0;
    }

    h5 {
        color: rgb(102, 102, 102, 1);
        text-transform: uppercase;
    }
    .activity-title {
        color: rgb(255, 255, 255, 1);
    }
    .activity-type {
        color: var(--color-primary-400);
        padding-bottom: 8px;
    }
    label {
        color: rgb(0, 0, 0, 1);
        font-size: 14px;
    }
    .activity-header {
        background-color: #323135;
        padding: 40px 32px;
    }
    .activity-header-content {
        display: flex;
    }
    .activity-content {
        flex-shrink: 1;
        flex-grow: 1;
        overflow: auto;
        padding: 16px;
    }
    .activity-subheader-wrapper {
        width: 100%;
        margin-bottom: 32px;
        display: flex;
        flex-wrap: wrap;
        text-transform: uppercase;
    }

    .cell {
        border: 1px solid #fff;
        background-color: #f2f5f8;
        padding: 10px 16px;
        width: 50%;

        &.wide {
            width: 100%;
        }

        &.formatted {
            text-transform: none;
        }
    }

    .activity-footer {
        & p {
            padding-top: 16px;
        }
    }
    .closeDrawer {
        color: var(--color-primary-100);
        font-family: 'Material Icons';
        font-size: 16px;
        line-height: 16px;
        display: block;
        cursor: pointer;
        visibility: visible;
        position: relative;
        top: -16px;
        right: -8px;
        float: right;
    }
}

@media (max-width: 500px) {
    .right-rail .right-drawer .right-drawer-content {
        outline: 10px red solid;
        min-width: initial !important;
        width: 100%;
    }
}
</style>
